import { PropTypes } from '@material-ui/core';
import { ReactNode } from 'react';
import { FieldUpdateArgs } from '../../../core/types/form';
import NetworkState from '../../../core/types/network';
import { ReduxAction, DispatchFunc } from '../../../core/types/redux';
import { Person } from '../person/types';

export enum MainActionConstants {
  MESSAGE_BOX_OPEN = '@@main/MESSAGE_BOX_OPEN',
  MESSAGE_BOX_CLOSE = '@@main/MESSAGE_BOX_CLOSE',
  SNACK_BAR_OPEN = '@@main/SNACK_BAR_OPEN',
  SNACK_BAR_CLOSE = '@@main/SNACK_BAR_CLOSE',
  NAVIGATE = '@@main/NAVIGATE',
  SETTINGS_POPUP_OPEN = '@@main/SETTINGS_POPUP_OPEN',
  SETTINGS_POPUP_CLOSE = '@@main/SETTINGS_POPUP_CLOSE',
  PROFILE_FIELD_UPDATE = '@@main/PROFILE_FIELD_UPDATE',
  PROFILE_UPDATE = '@@main/PROFILE_UPDATE',
  PROFILE_UPDATED_SET = '@@main/PROFILE_UPDATED_SET',
  PASSWORD_UPDATE = '@@main/PASSWORD_UPDATE',
  PASSWORD_UPDATED_SET = '@@main/PASSWORD_UPDATED_SET',
}

export interface MessageBoxCommand {
  title: string;
  action: () => void;
  color?: PropTypes.Color;
}

export type Page = 'main'
| 'login'
| 'result'
| 'resultDetails'
| 'resultPreview';

export type Routes = Record<Page, string>;

export type MessageBoxType = 'info' | 'warning' | 'error' | 'question';
export type SnackbarColor = 'success' | 'info' | 'warning' | 'error';

export interface MessageBoxInfo {
  title?: string;
  content?: string | ReactNode | ReactNode[];
  mode?: MessageBoxType;
  commands?: MessageBoxCommand[];
  dismissText?: string;
  blurBackdrop?: boolean;
  onDismiss?: Function;
}

export type OpenMessageBoxArgs = MessageBoxInfo;

export type NavigateArgs = {
  page: Page;
  params?: Record<string, string>;
  target?: string;
};

export interface OpenSnackBarArgs {
  severity?: SnackbarColor;
  messageSnackbar?: string;
}

export interface UserProfile extends Record<string, unknown> {
  userId: string;
  username: string;
  userPersonName?: Person;
  userPosition?: string;
  userType?: string;
  userCurrentPassword?: string;
  userNewPassword?: string;
  userRePassword?: string;
}

export interface OpenSettingPopupArgs extends UserProfile {}
export interface RequestUpdateProfileArgs extends UserProfile {}
export interface RequestUpdatePasswordArgs extends UserProfile {
  mode: string;
}

export interface SetUpdatedProfileArgs {
  result?: ProfileResult;
  error?: Error;
}

export interface ProfileResult {
  isSuccess: boolean;
  loginProfile: UserProfile;
  message?: string;
}

export interface UpdateProfileFieldArgs extends FieldUpdateArgs<unknown> {}

export type MainAction<TArgs = unknown> = ReduxAction<TArgs, MainActionConstants>;
export type MainDispatchFunc<TArgs = unknown> = DispatchFunc<TArgs, MainActionConstants>;

export interface MainState {
  networkStates: {
    updateProfileRequest: NetworkState;
    updatePasswordRequest: NetworkState;
  };
  isMessageBoxOpen: boolean;
  messageBoxInfo?: MessageBoxInfo;
  snackbarInfo: {
    isSnackbarOpen: boolean;
    severity?: SnackbarColor;
    messageSnackbar?: string;
  };
  settingsPopup: {
    isOpen: boolean;
    userProfile?: UserProfile;
  };
}
